// @flow
import React from 'react';

type Props = {
  img: string,
  click: (e: SyntheticEvent<HTMLDivElement | HTMLImageElement>) => void,
  buttonClass?: string,
  buttonIndex?: number,
  audio?: string,
  showArrow: Boolean,
};

export default class Button extends React.PureComponent<Props> {
  click: (e: SyntheticEvent<HTMLDivElement | HTMLImageElement>) => void;
  audioClip: HTMLAudioElement;

  componentDidMount = () => {
    if (this.props.audio) {
      this.audioClip = document.createElement('audio');
      this.audioClip.src = this.props.audio || '';
    }
  };

  playAudio = () => {
    if (!this.audioClip) return;
    this.audioClip.play();
  };

  render(): React$Element<any> {
    return (
      <div
        className={`flex items-center h-16 w-16 xl:h-20 xl:w-20 justify-center ${this.props.buttonClass}`}
        onMouseOver={this.playAudio}
        onClick={this.props.click}
        buttonid={this.props.buttonIndex}
      >
        {this.props.showArrow && <img src={this.props.img} alt="button" />}
      </div>
    );
  }
}
